import axiosConfig from './axiosConfigInstance';

const SESSION_KEY = 'plans_page_session_id';

const getSessionId = () => {
  try {
    let sessionId = sessionStorage.getItem(SESSION_KEY);
    if (!sessionId) {
      sessionId = `plans_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
      sessionStorage.setItem(SESSION_KEY, sessionId);
    }
    return sessionId;
  } catch {
    return `plans_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
  }
};

export const trackPlansPageEvent = (payload = {}) => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');

    const body = {
      sessionId: getSessionId(),
      eventName: payload.eventName,
      eventAction: payload.eventAction || 'click',
      planId: payload.planId,
      billingCycle: payload.billingCycle,
      page: payload.page || window.location.pathname,
      email: payload.email || userData.email,
      userId: payload.userId || userData._id || userData.id || userData.userId,
      source: payload.source || 'plans_page',
      clientTimestamp: new Date().toISOString(),
      meta: payload.meta || {},
    };

    return axiosConfig
      .post(`${import.meta.env.VITE_APP_API_URL}/chargebee/plans-page-click`, body)
      .catch(() => null);
  } catch {
    return Promise.resolve(null);
  }
};
